import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param candidateData: object
// example:
// {
//   "full_name": "Balqees qasem"
// }
export function membershipApplications(data: object): Promise<ApiResponse> {
  return Axios.post("/v1/tutor_membership_applications", data);
}
